import { render, staticRenderFns } from "./legal-form.vue?vue&type=template&id=0c4547bc&"
import script from "./legal-form.vue?vue&type=script&lang=js&"
export * from "./legal-form.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports